import {
  FETCH_EXPENSES,
  FETCH_EXPENSES_SUCCESS,
  FETCH_EXPENSES_ERROR,
  FETCH_EXPENSES_SERVER_ERROR,
  TOGGLE_TABS,
  TOGGLE_ROAMING,
  FILTER_PATH_CTN,
  TABLE_FILTERS,
  TABLE_FILTERS_CLEAR,
  MODIFY_CTN_CARD,
  ACCUMULATOR_TREE,
  ACCUMULATOR_TREE_LINKS,
  SORT_CTN_BLOCK,
} from './constants';

export const expensesInitialState = {
  isFetching: true,
  isReportSending: false,
  reportSendingError: null,
  activeTabs: 'debit',
  aggregateType: null,
  roaming: false,
  structure: [],
  callDetails: [],
  ctn: [],
  incorrectPeriod: false,
  tableFilters: {},
};

const filter = (data, filterType, filters, callableFilters = {}) => {
  if (filterType === 'aggregateType') {
    const aggregateTypeFiltred = Object.entries(MODIFY_CTN_CARD).filter(([key]) => MODIFY_CTN_CARD[key]).find(([, value]) => value.path === data)?.[0];

    return aggregateTypeFiltred;
  }

  if (filterType === 'ctn') {
    const ctnCardFilter = data.filter((item) => [
      'LOCAL_INTERNET_ND',
      'LOCAL_OUTCOMING_CALLS',
      'LOCAL_OUTCOMING_SMS_MMS',
      'INTERNATIONAL_ROAMING_INTERNET',
      'INTERNATIONAL_ROAMING_SMS_MMS',
      'INTERNATIONAL_ROAMING_OUTCOMING_CALLS',
    ].includes(item.id));

    const ctnTabs = data.filter((item) => item.id === 'INTERNATIONAL_ROAMING');

    const ctnCardWithModify = ctnCardFilter.filter((el) => el.id in MODIFY_CTN_CARD).map((el) => ({
      ...el,
      sortId: SORT_CTN_BLOCK[el.id] ?? 999,
      href: MODIFY_CTN_CARD[el.id].path,
      hrefText: MODIFY_CTN_CARD[el.id].pathName,
      img: MODIFY_CTN_CARD[el.id].img,
      defaultUnit: MODIFY_CTN_CARD[el.id].defaultUnit.toUpperCase(),
      defaultTraffic: 0,
      title: MODIFY_CTN_CARD[el.id].defaultTitle,
    })).sort((a, b) => a.sortId - b.sortId);

    const ctnRoaming = ctnCardWithModify.filter((el) => el.id.startsWith('INTERNATIONAL_ROAMING_'));
    const ctnNoRoaming = ctnCardWithModify.filter((el) => el.id.startsWith('LOCAL_'));

    return { ctnRoaming, ctnNoRoaming, ctnTabs };
  }

  if (filterType === 'debit') {
    const debit = data?.filter((item) => item?.balances[0].valueChange < 0 && item?.balances[0].unitCode === 'CURRENCY');

    const KEYS = Object.keys(ACCUMULATOR_TREE_LINKS);

    // eslint-disable-next-line no-return-assign, no-sequences
    const ACCUMULATOR_COLORS = KEYS.reduce((acc, name) => (acc[name] = ACCUMULATOR_TREE_LINKS[name]?.color, acc), {});

    const walkEveryAccum = (root, callback) => {
      root.children.forEach((child) => {
        callback(root, child);
        walkEveryAccum(child, callback);
      });
    };
    // eslint-disable-next-line no-param-reassign
    walkEveryAccum(ACCUMULATOR_TREE, (root, child) => { child.color ??= root.color; });

    const debitByCategory = debit.reduce((acc, entry) => {
      const id = entry.filterId;

      if (!(id in acc)) acc[id] = 0;
      if (!(Object.values(callableFilters).every((x) => x(entry)))) return acc;
      acc[id] += entry.balances[0].valueChange;
      return acc;
    }, {});

    const filterName = filters?.filter((item) => item?.isAccumulator === true);

    const sumOfTree = (root) => (debitByCategory[root.id] ?? 0) + root.children.reduce((accSum, child) => accSum + sumOfTree(child), 0);
    const sumTotal = sumOfTree(ACCUMULATOR_TREE).toFixed(2).replace(/\.00$/, '');

    const sumDeepCategory = Object.fromEntries(filterName.map((name) => [name.id, sumOfTree(ACCUMULATOR_TREE_LINKS[name.id])]));

    const category = Object.fromEntries(Object.entries(sumDeepCategory).filter(([key, value]) => value < 0).map(([x, y]) => [x, {
      color: ACCUMULATOR_COLORS[x],
      width: `${Math.round(Math.abs(y / Math.abs(sumTotal) * 100))}%`,
      cost: Math.abs(sumDeepCategory[x]).toFixed(2).replace(/\.00$/, ''),
    }]));

    const AccumWithModify = filterName.filter((el) => el.id in category).map((el) => ({
      ...el,
      width: category[el.id].width,
      cost: category[el.id].cost,
      color: category[el.id].color,
    })).sort((a, b) => b.cost - a.cost);

    const balanceDropdownMap = {};
    balanceDropdownMap.empty = 'Все балансы';
    debit.forEach((entry) => {
      const id = entry.balances[0].nameCode;
      balanceDropdownMap[id] = entry.balances[0].balanceText;
    });

    return { debit, accumulators: { sumTotal, AccumWithModify }, dropdown: balanceDropdownMap };
  }

  if (filterType === 'payment') {
    const payment = data.filter((item) => item.value > 0);

    return payment;
  }
};

const expenses = (state = expensesInitialState, action) => {
  switch (action.type) {
    case FETCH_EXPENSES:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_EXPENSES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        structure: action.data.filters,
        callDetails: filter(action.data.callDetails, 'debit', action.data.filters),
        incorrectPeriod: action.data.incorrectPeriod,
        totalBalance: {
          ...state.totalBalance,
          debit: action.data.totalBalanceChange,
        },
        ctn: filter(action.data.filters, 'ctn'),
      };

    case FETCH_EXPENSES_ERROR:
      return {
        ...state,
        isFetching: false,
      };

    case FETCH_EXPENSES_SERVER_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case TOGGLE_TABS:
      return {
        ...state,
        activeTabs: action.data,
      };
    case TOGGLE_ROAMING:
      return {
        ...state,
        roaming: action.data,
      };
    case FILTER_PATH_CTN:
      return {
        ...state,
        aggregateType: filter(action.data, 'aggregateType'),
      };
    case TABLE_FILTERS:
      return {
        ...state,
        tableFilters: { ...state.tableFilters, [action.name]: action.filter },
        callDetails: filter(
          [...state.callDetails.debit],
          'debit',
          [...state.structure],
          { ...state.tableFilters, [action.name]: action.filter },
        ),
      };
    case TABLE_FILTERS_CLEAR:
      return {
        ...state,
        tableFilters: Object.fromEntries(Object.entries(state.tableFilters).filter(([key]) => key !== action.name)),
        callDetails: filter(
          [...state.callDetails.debit],
          'debit',
          [...state.structure],
          Object.fromEntries(Object.entries(state.tableFilters).filter(([key]) => key !== action.name)),
        ),
      };
    default:
      return state;
  }
};

export default expenses;
